const URL = {
  COURSE_LIST: 'Course/GetByFilter',
  GET_ASSIGNMENT: 'Course/GetById',
  GET_COURSE: 'Course/{id}',
  ADD_COURSE: 'Course/Create',
  EDIT_COURSE: 'Course/Edit',
  DELETE_COURSE: 'Course/Delete',
  PATCH_COURSE: 'Course/Patch',
  REMOVE_QUESTION_ASSIGNMENT: 'Course/RemoveQuestionsFromCourse',
  OPENAI_SEND_REQUEST: 'OpenAI/SendRequest',
  OPENAI_SEND_CARD_REQUEST: 'OpenAI/SendCardRequest',
  OPENAI_SEND_COURSE_CREATION_GET_TITLE_REQUEST:
    'OpenAI/SendCourseCreationGetTitleRequest',
  OPENAI_SEND_COURSE_CREATION_GET_OUTLINE_REQUEST:
    'OpenAI/SendCourseCreationGetOutlineRequest',
  OPENAI_SEND_COURSE_CREATION_REQUEST: 'OpenAI/SendCourseCreationRequest',
  CLONE_COURSE: 'Course/Clone',
  GET_COURSE_TRANSLATIONS: 'Course/{courseId}/Translations',
  CARD_PATCH_LINK: 'Card/PatchLink',
  PATCH_COURSE_SETTING: 'Course/PatchSetting',
  PATCH_COURSE_SETTING_BY_ID: 'course/{id}/setting/{settingId}',
  CREATE_COURSE_SETTING: 'Course/CreateSetting',
  CLONE_TEMPLATE_COURSE: 'Course/CloneTemplateCourse',
  CREATE_PROMPT_FROM_CARD: 'OpenAI/SendCreatePromptFromCardContentRequest',
  GET_COURSE_ANALYTICS: 'Report/GetCourseAnalyticsById',
  GET_COURSE_ANALYTICS_REPORT: 'course/{id}/analytics/report',

  CREATE_SECTION_WITH_CARD_IDS: 'section/create',
  PATCH_SECTION: 'section/patch',
  GET_QUIZZES_BY_COURSE_ID: 'LlmApi/CreateQuizFromCourse',
  GET_COURSE_CREATION_PROGRESS: 'course/{id}/card-creation-progress',
  EXPORT_COURSE_TO_SCORM: 'course/{id}/export-to-scorm',

  GET_COURSE_LANDING_PAGE: 'course/{id}/landing-page',
  PATCH_COURSE_LANDING_PAGE: 'course/{id}/landing-page',

  EDIT_SECTION_ORDER: 'course/{id}/sections',
  ADD_SECTION: 'section/create',
  CREATE_COURSE: 'course',

  GENERATE_CARD: 'card/generate',
  GENERATE_ACTIVITY: 'Activity/generate',

  COURSE_FILTER: 'course/filter',

  GET_COURSE_ATTACHMENTS: 'course/{courseId}/attachments',

  PUBLISH_COURSE: 'course/{id}/publish',
  UNPUBLISH_COURSE: 'course/{id}/unpublish',
  PUBLISH_COURSE_CHANGES: 'course/{id}/publish-changes',
  UPDATE_COURSE_CODE: 'course/{id}/code',
  GET_COURSE_PUBLISH_STATE: 'course/{id}/publish-state',
  GET_COURSE_PREVIEW_TOKEN: 'course/{id}/preview-token',
}

export default URL
